import { render, staticRenderFns } from "./CustomerInfoForm.vue?vue&type=template&id=14dd1ca5&scoped=true&"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoForm.vue?vue&type=style&index=0&id=14dd1ca5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd1ca5",
  null
  
)

export default component.exports